import { render, staticRenderFns } from "./CFRubricGrid.vue?vue&type=template&id=4e57d5a0"
import script from "./CFRubricGrid.vue?vue&type=script&lang=js"
export * from "./CFRubricGrid.vue?vue&type=script&lang=js"
import style0 from "./CFRubricGrid.vue?vue&type=style&index=0&id=4e57d5a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports